
import { Component, Ref, Vue } from "vue-property-decorator";
import SpatialNavigation from "spatial-navigation-js";
import apiService from "@/services/apiService/apiService";
import { Alert } from "bootstrap";
import { Action, Mutation } from "vuex-class";
import { SettingsMutations } from "@/components/settings/types";
import { Namespace } from "@/store/types";
import { keyCodeFinder } from "@/services/keyCodeService/keyCodeService";
import { KeySet } from "@/services/keyCodeService/keyCode.types";
import { RouteName } from "@/router/types";
import { LocaleSettingsPinModal } from "@/plugins/i18n/types";
import { AlertAction, AlertState, AlertType } from "@/components/alert/types";

@Component({})
export default class PinOverlay extends Vue {
  @Ref("alertBottom") readonly alertBottom!: Element;

  @Action(AlertAction.UpdateAlert, { namespace: Namespace.Alert })
  alertReset!: (alertData: AlertState) => void;

  @Mutation(SettingsMutations.setEncodedPin, { namespace: Namespace.Settings })
  setEncodedPin!: (pin: string) => void;

  @Mutation(SettingsMutations.setPinOverlay, { namespace: Namespace.Settings })
  setPinOverlay!: (pinOverlayStatus: boolean) => void;

  pin = "";
  alertMsg = "";
  alertInstance!: Alert;

  LocaleSettingsPinModal = LocaleSettingsPinModal;

  mounted(): void {
    SpatialNavigation.focus(".settings-pin__container__input");
    this.alertInstance = new Alert(this.alertBottom);
  }

  get bgColor(): string {
    return this.$route.name === RouteName.Player
      ? "black"
      : " rgba(0, 0, 0, 0.5)";
  }

  async verifyPin(): Promise<void> {
    try {
      await apiService.verifyPin({
        pin_code: this.pin ? this.pin.toString() : ""
      });

      this.setEncodedPin(this.pin);
      this.setPinOverlay(false);
    } catch (e) {
      switch (e.response.status) {
        case 423:
          this.alertReset({
            show: true,
            message: e.response.data.message,
            alertType: AlertType.Danger
          });
          break;
        case 500:
          this.alertReset({
            show: true,
            message: "Network Error",
            alertType: AlertType.Danger
          });
          break;
      }
    }
  }

  handleActions(event: KeyboardEvent): void {
    switch (keyCodeFinder(event.keyCode)) {
      case KeySet.KEY_UP:
        SpatialNavigation.focus("#pin");
        break;
      case KeySet.KEY_DOWN:
        SpatialNavigation.focus("#pinBtn");
        break;
      case KeySet.KEY_BACK:
        if (document.activeElement?.id === "pin") {
          if (this.pin.length > 0) {
            this.pin.slice(0, -1);
            return;
          }
        }

        this.setPinOverlay(false);
        break;
    }
  }
}
